const scrollingMenu = document.querySelector('.scrolling-sidemenu');

if (scrollingMenu) {
  const setSideMenuImageHeight = () => {
    const sideMenuTop = scrollingMenu.querySelector('.scrolling-sidemenu__top');
    const sideMenuImage = scrollingMenu.querySelector('.scrolling-sidemenu__image');

    sideMenuImage.style.height = `${sideMenuTop.getBoundingClientRect().bottom + window.scrollY}px`;
  };

  const handleScroll = () => {
    const sideMenuImage = scrollingMenu.querySelector('.scrolling-sidemenu__image');
    const linkBox = scrollingMenu.querySelector('.link-box');

    const imageBottom = sideMenuImage.getBoundingClientRect().bottom + window.scrollY - 80;
    linkBox.classList.toggle('secondary', window.scrollY > imageBottom);
  };

  setSideMenuImageHeight();
  handleScroll();
  window.addEventListener('resize', setSideMenuImageHeight);
  window.addEventListener('scroll', handleScroll);
}
